/*
 * Copyright (c) 2024 Via Transportation, Inc. All rights reserved.
 *
 * This software is distributed under license and may not be used, copied,
 * modified, or distributed without the express written permission of
 * Via Transportation, Inc.
 */

import { makeStyles } from "@material-ui/core/styles";

import backgroundMap from "resources/map.svg";

export const useClasses = makeStyles((theme) => ({
    container: {
        display: "flex",
        height: "100%",
    },
    content: {
        marginTop: theme.spacing(7),
    },
    loginForm: {
        backgroundColor: "#FFFFFF",
        padding: theme.spacing(8),
        width: "484px",
        borderRadius: `0 ${theme.spacing(4)}px ${theme.spacing(4)}px 0`,
        boxShadow: "0px 2px 4px 0px #15161A26",
        zIndex: 10,
        flexShrink: 0,
    },
    backgroundImg: {
        width: "100%",
        height: "100%",
        marginLeft: "-20px",
        backgroundImage: `url(${backgroundMap})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
    },
}));
